import { FeatureFlag } from '@lingoda/monolith-graphql';
import { hasFeature } from './utils';

export const isBookBeforeTrialEnabled = () => hasFeature(FeatureFlag.BookClassBeforeTrialStart);

export const isNoCreditCardTrialEnabled = () =>
    hasFeature(FeatureFlag.SkipCreditCardForTrialDirectPurchase);

export const isLivePracticeEnabled = () => hasFeature(FeatureFlag.LivePractice);

export const isSelfLearningLimitAccessEnabled = () =>
    hasFeature(FeatureFlag.SelfLearningLimitAccess);

export const isFlashNotificationsEnabled = () => !hasFeature(FeatureFlag.HideFlashNotifications);

export const isShareCertificateEnabled = () => hasFeature(FeatureFlag.ShareCertificate);

export const isEmailVerificationEnabled = () => hasFeature(FeatureFlag.EmailVerification);

export const isLeadConversionFlowEnabled = () => hasFeature(FeatureFlag.LeadConversionFlow); // ??

export const isNewCoursePageEnabled = () => hasFeature(FeatureFlag.MyCourseUpgrade); // it's feature logic now

export const isQuizEngineEnabled = () => hasFeature(FeatureFlag.QuizEngine);

export const isNudgeForPlanningEnabled = () => hasFeature(FeatureFlag.NudgeForPlanning);

export const isOnboardingChecklistEnabled = () => hasFeature(FeatureFlag.OnboardingChecklist);

export const isOnboardingChecklistRevampEnabled = () =>
    hasFeature(FeatureFlag.OnboardingChecklistRevamp);

export const isVocabErrorReportingEnabled = () => hasFeature(FeatureFlag.VocabTrainerContentErrors);

export const isSprintBookingPreviewEnabled = () => hasFeature(FeatureFlag.SprintPrePayment);

export const isVocabularyGoalSettingEnabled = () => hasFeature(FeatureFlag.VocabularyGoalSetting);

export const isAfterBookingFeedbackSurveyEnabled = () => false; // we may want to enable it in the future

export const isMixedCreditsEnabled = () => hasFeature(FeatureFlag.MixedCredits);

export const isStudentProfilePageEnabled = () => hasFeature(FeatureFlag.StudentProfile);

export const isOldPracticeMaterialsEnabled = () => !hasFeature(FeatureFlag.OldPracticeDisabled);

export const isLingobitesUnlocked = () => hasFeature(FeatureFlag.UnlockedLingobites);

export const isQuizTranslationsEnabled = () => hasFeature(FeatureFlag.WordByWordTranslations);

export const isAiAudioRecordingEnabled = () => hasFeature(FeatureFlag.AiAudioRecording);
